export const FETCH_PERSON = "fetchPerson";
export const FETCH_PERSONNEL = "fetchPersonnel";
export const SAVE_NEW_PERSON = "saveNewPerson";
export const SAVE_PERSON_MAIN_DETAILS_FIELD = "savePersonMainDetailsField";
export const SEND_DETAILS_CONFIRMATION = "sendDetailsConfirmation";


